import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Network, NetworkOverview, NetworkServer, NetworkService} from "../../../../../../services/back/network.service";
import {finalize, Observable, of, Subscription, switchMap, tap} from "rxjs";
import {NetworkDetailData, NetworkDetailService} from "../../../../../../services/front/network-detail.service";
import {DesignSystemModule} from "../../../../../design-system/design-system.module";
import {CommonModule} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {NetworkInformationFormComponent} from "./network-information-form/network-information-form.component";
import {NetworkServersComponent} from "./network-servers/network-servers.component";
import {DashboardPageLoaderComponent} from "../../../../../global/title-content-loader/dashboard-page-loader.component";

@Component({
	selector: 'app-network-overview-tab',
	standalone: true,
	imports: [
		CommonModule,
		DesignSystemModule,
		TranslateModule,
		NetworkInformationFormComponent,
		NetworkServersComponent,
		DashboardPageLoaderComponent
	],
	templateUrl: './network-overview-tab.component.html',
	styleUrl: './network-overview-tab.component.scss'
})
export class NetworkOverviewTabComponent implements OnInit, OnDestroy {
	@Input() tabActive: boolean;

	tenantId: string;
	isEditor: boolean;
	isTenantInactivePlan: boolean;

	network: Network;

	servers: NetworkServer[] = [];

	_initializing: boolean;
	_loading: boolean;
	initialized: boolean = false;

	ipPoolPercentage: number;
	firewall: boolean = false;
	tooMuchServers: boolean = false;

	subscription: Subscription = new Subscription();

	constructor(private networkDetailService: NetworkDetailService,
				private networkService: NetworkService) {
	}

	ngOnInit() {
		this.subscription.add(this.networkDetailService.getInitializingChanges()
			.subscribe(initializing => this._initializing = initializing));
		this.subscription.add(this.networkDetailService.getNetworkDetailDataChanges()
			.pipe(tap(data => this.setNetworkDetailData(data)))
			.subscribe(() => this.initialize()));
	}

	private setNetworkDetailData(data: NetworkDetailData): void {
		this.tenantId = data.tenantId;
		this.isEditor = data.isEditor;
		this.network = data.network;
		this.isTenantInactivePlan = data.isInactivePlan;
	}

	initialize(): void {
		this.subscription.add(this.switchLoading()
			.pipe(
				switchMap(() => this.networkService.getNetworkOverview(this.tenantId, this.network.id)),
				tap((data) => this.setData(data)),
				finalize(() => this.switchLoading()))
			.subscribe(() => this.initialized = true));
	}

	setData(data: NetworkOverview): void {
		this.firewall = data.hasFirewall;
		this.servers = data.servers;
		this.ipPoolPercentage = data.ipPoolPercentage;
		this.servers = data.servers;
		this.tooMuchServers = data.tooMuchServers;
	}

	private switchLoading(): Observable<{}> {
		this._loading = !this._loading;
		return of({});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}
}
